export const formatRupiah = (value) => {
  const n = Number(value || 0);
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n);
};

export const formatNumber = (value) =>
  new Intl.NumberFormat("id-ID").format(Number(value || 0));

export const formatDate = (value) => {
  if (!value) return "-";
  try {
    const d = new Date(value.length === 10 ? value + "T00:00:00" : value);
    return new Intl.DateTimeFormat("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(d);
  } catch {
    return value;
  }
};

export const formatDateShort = (value) => {
  if (!value) return "-";
  try {
    const d = new Date(value.length === 10 ? value + "T00:00:00" : value);
    return new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(d);
  } catch {
    return value;
  }
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const formatApiError = (detail) => {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const STATUS_LABELS = {
  draft: "Draft",
  pending: "Pending",
  paid: "Lunas",
  unpaid: "Belum Bayar",
  cancel: "Dibatalkan",
  approved: "Disetujui",
  rejected: "Ditolak",
};
